import { render, staticRenderFns } from "./changeorderstatus.vue?vue&type=template&id=46385bb6"
import script from "./changeorderstatus.vue?vue&type=script&lang=js"
export * from "./changeorderstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports